import React, { useEffect } from "react";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import cardpictures1 from "../Images/Icones/CardPictures1.svg";
import FavoriteIcon from '@mui/icons-material/Favorite';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import IconButton from '@mui/material/IconButton';
import "./Styles/BasicCard.css"
import { fontStyle } from "@mui/system";
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import Slider from "react-slick";
import { priceFr } from "../Services/Numbers";
import { isProductInCart, getCart, setCart, addProductInCart, addProductInFavourites, getFavourites, isProductInFavourites } from '../Services/localStorage';
import { useState } from 'react';
import Cookies from 'universal-cookie';

export default function BasicCard({ product = {} }) {
  const productsURL = process.env.REACT_APP_API_BASE_URL + '/images/products/';

  useEffect(() => {
    setInFav(isProductInFavourites(product.id))
    setInCart(isProductInCart(product.id))
  })

  const cookies = new Cookies();

  const [inFav, setInFav] = useState(false)
  const [inCart, setInCart] = useState(false)

  let stars = [];
  for (let i = 0; i < product.stars; i++) {
    stars.push(<StarIcon key={'full-star_' + product.slug + '_' + (i + 1)} sx={{ color: 'gold', fontSize: '20px' }} />);
  }

  if (product.stars < 5) {
    for (let i = 0; i < 5 - product.stars; i++) {
      stars.push(<StarOutlineIcon key={'empty-star_' + product.slug + '_' + (i + 1)} sx={{ color: 'gold', fontSize: '20px' }} />);
    }
  }

  let prices = '';
  let badge = '';

  if (product.discount) {
    let oldPrice = product.price;
    let newPrice = oldPrice - Math.round(oldPrice * product.discount / 100)
    prices = (<>
      <p className="PrixStyle">{priceFr(newPrice)} F</p>
      <p className="PrixBarreStyle">{priceFr(oldPrice)} F</p>
    </>)

    badge = <span className="badge">-{product.discount}%</span>
  }
  else {
    prices = (<>
      <p className="PrixStyle">{priceFr(product.price)} F</p>
    </>)
  }

  const addToCart = () => {
    addProductInCart(product, 1)
    setInCart(isProductInCart(product.id))
  }

  const addToFav = () => {
    addProductInFavourites(product)
    setInFav(isProductInFavourites(product.id))
  }

  const goToProduct = (slug) => {
    window.location.href = "/boutique/"+slug;
  }

  return (
    <div className="container-card">
      <Card sx={{ position: 'relative', minHeight: 330 }}>

        <CardMedia
        onClick={()=>{goToProduct(product.slug)}}
          sx={{ height: 188 }}
          image={productsURL + product.thumb}
          style={{ backgroundColor: "#fff", width: "100%", objectFit: 'cover', marginBottom: '10px' }}
          title={product.slug}
        />

        <CardContent sx={{ padding: '5px' }}>
          <p className="ProductName">
            {product.name}
          </p>
          <div className="stars">
            {stars}
          </div>
          <div className="GrandCard">
            <div className="MiniCard">
              {prices}
            </div>
            <div className="CartAndFavorite">
              <CardActions sx={{ width: "100%", justifyContent: 'space-between', marginTop: "5px" }}>
                {
                  inCart ?
                    cookies.get('user') ?
                      (
                        <ShoppingCartIcon sx={{ color: "#80377D", fontSize: '28px', width: "50%" }} />
                      ) :
                      (
                        <button onClick={() => { addToCart() }} className="full-btn-cart-active"><span className="cartIcon"><ShoppingCartIcon sx={{ color: '#fff' }} /></span></button>
                      )
                    :
                    cookies.get('user') ?
                      (
                        <IconButton onClick={() => { addToCart() }} sx={{ padding: '3px', backgroundColor: '#ededff' }} aria-label="add to cart">
                          <AddShoppingCartIcon sx={{ fontSize: "25px", borderStyle: 'solid', borderRadius: '50%', borderWidth: '6px', borderColor: '#EDEDFF' }} />
                        </IconButton>
                      ) :
                      (
                        <button onClick={(e) => { addToCart() }} className="full-btn-cart"><span className="cartIcon"><AddShoppingCartIcon sx={{ color: '#fff' }} /></span></button>
                      )
                }
                {
                  cookies.get('user') ?
                    inFav ?
                      (
                        <FavoriteIcon sx={{ color: "#ba0001", fontSize: '28px', width: "50%" }} />
                      ) :
                      (
                        <IconButton onClick={() => { addToFav() }} sx={{ padding: '3px', backgroundColor: '#ededff' }} aria-label="add to favorites">
                          <FavoriteIcon sx={{ fontSize: "25px", borderStyle: 'solid', borderRadius: '50%', borderWidth: '6px', borderColor: '#EDEDFF' }} />
                        </IconButton>
                      ) : ''
                }

              </CardActions>
            </div>
          </div>
        </CardContent>
        {badge}
      </Card>
    </div>
  );
}